// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewContact .table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
}

.viewContact .table-bordered {
  border: 1px solid #ddd;
}

.viewContact .table-bordered td {
  border: 1px solid #ddd;
  border-radius: 0;
  background-color: #ffffff;
  padding: 8px 6px;
}

.viewContact th,
.viewContact td {
  border-top: 0 none !important;
}

.viewContact th {
  background-color: #f2f2f2;
}

.swal2-container {
  z-index: 99999 !important;
}

/* CustomToast.css */
.no-shadow-toast .Toastify__toast {
  box-shadow: none !important;
}

.simplebar-placeholder {
  display: none !important;
}



.css-1swivyk-MuiInputBase-input-MuiOutlinedInput-input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 100px #1E1E2D inset;
  -webkit-text-fill-color: #fff;
  caret-color: #fff;
  border-radius: inherit;
}

.css-jtnu8p-MuiInputBase-input-MuiOutlinedInput-input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 100px #1E1E2D inset;
  -webkit-text-fill-color: #fff;
  caret-color: #fff;
  border-radius: inherit;
}

.link {
  text-decoration: none;
  color: #fff;
}

textarea::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.toolbar {
  background-color: #333;
  color: black;
}

.rdw-option-wrapper,
.rdw-dropdown-selectedtext {
  display: flex;
  height: 30px;
  justify-content: 'space-between';
}

.wrapper {
  background-color: #333;
  border-radius: 10px;
  overflow: hidden;
  height: 300px;
  padding-bottom: 70px;
  transition: 1s all ease;
}

.wrapper:hover {
  outline: 1px solid #fff;
}

/* For WebKit browsers (Chrome, Safari) */
.editor::-webkit-scrollbar {
  width: 12px;
  /* Width of the scrollbar */
}

.editor::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* Background of the scrollbar track */
  border-radius: 10px;
  /* Rounded corners for the track */
}

.editor::-webkit-scrollbar-thumb {
  background: #888;
  /* Color of the scrollbar thumb */
  border-radius: 10px;
  /* Rounded corners for the thumb */
}

.editor::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* Darker color when hovering over the thumb */
}

/* For Firefox */
.editor {
  scrollbar-width: thin;
  /* Makes the scrollbar thinner */
  scrollbar-color: #888 #f1f1f1;
  /* Thumb color and track color */
}

/* For Internet Explorer and Edge (if needed) */
.editor {
  -ms-overflow-style: -ms-autohiding-scrollbar;
  /* Hides scrollbar when not in use */
}

.editor {
  background-color: #333;
  padding: 0 10px;
}

.rdw-editor-toolbar {
  border: 1px solid #333;
}

p {
  margin: 0;
  padding: 0;
}

.custom-select-2 .ant-select-selector {
  background-color: #333 !important;
  color: #fff !important;
  padding: 5px 0;
}

.custom-select-2 .ant-select-selection-item {
  color: #fff !important;
}

/* Style for dropdown menu */
.custom-select-2 .ant-select-dropdown {
  background-color: #333 !important;
}

/* Style for dropdown items */
.custom-select-2 .ant-select-item-option {
  background-color: #333 !important;
  color: #fff !important;
}

/* Style placeholder text color */
.custom-select-2 .ant-select-selection-placeholder {
  color: #888888 !important;
}

.custom-popup-select {
  background-color: #333 !important;
}

.custom-select .ant-select-selector {
  background-color: #333 !important;
  color: #fff !important;
  border-color: #333 !important;
  padding: 5px 0;
}

/* Style for dropdown menu */
.custom-select .ant-select-dropdown {
  background-color: #333 !important;
}

/* Style for dropdown items */
.custom-select .ant-select-item-option {
  background-color: #333 !important;
  color: #fff !important;
}

/* Style placeholder text color */
.custom-select .ant-select-selection-placeholder {
  color: #bbb !important;
}

.anticon,
.anticon-close {
  color: #fff
}

.ant-modal-content,
.ant-picker {
  background-color: #333 !important;
  color: #fff !important;
}

.ant-modal-content>div {
  background-color: #333 !important;
  /* color: #fff !important; */
}

.ant-modal-body {
  background-color: #333 !important;
}

.ant-col>label {
  color: #fff !important;
}

.ant-input::placeholder,
.ant-picker-input>input::placeholder {
  color: gray !important;
}

.ant-picker-input-placeholder>input {
  color: gray !important;
}

.ant-picker {
  background-color: #333 !important;
}

/* Ensure all child elements (like input, buttons, etc.) inside .custom-popup are styled */
.custom-popup * {
  background-color: #333 !important;
  color: #fff !important;
}

/* Style the DatePicker dropdown specifically */
.custom-popup .ant-picker-dropdown {
  background-color: #333 !important;
  color: #fff !important;
}

/* Style the cells inside the dropdown */
.custom-popup .ant-picker-cell-inner {
  color: #fff !important;
}

/* Optional: hover state for date cells */
.custom-popup .ant-picker-cell:hover .ant-picker-cell-inner {
  background-color: #444 !important;
  color: #fff !important;
}

/* Highlight selected date inside the dropdown */
.custom-popup .ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: #0BD349 !important;
  color: #000 !important;
}



.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner {
  background-color: #27c456 !important;
}

.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
  background-color: #27c456 !important;
}

.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
  border-color: #1f9643e5 !important;
}

.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
.ant-picker-cell-in-view.ant-picker-cell-in-range::before,
.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before,
.ant-picker-time-panel-column>li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
  background: #444 !important;
}

.ant-btn-primary {
  background-color: #27c456 !important;
  border-color: #1f9643e5 !important;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;;;AAIA;EACE,6CAA6C;EAC7C,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,gCAAgC;EAChC,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA,+CAA+C;AAC/C;EACE,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,iCAAiC;AACnC;;AAEA,6BAA6B;AAC7B;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,iCAAiC;AACnC;;AAEA,6BAA6B;AAC7B;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;AACxB;;AAEA;;EAEE;AACF;;AAEA;;EAEE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,0FAA0F;AAC1F;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;;;AAIA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;AAClB","sourcesContent":[".viewContact .table {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.viewContact .table-bordered {\n  border: 1px solid #ddd;\n}\n\n.viewContact .table-bordered td {\n  border: 1px solid #ddd;\n  border-radius: 0;\n  background-color: #ffffff;\n  padding: 8px 6px;\n}\n\n.viewContact th,\n.viewContact td {\n  border-top: 0 none !important;\n}\n\n.viewContact th {\n  background-color: #f2f2f2;\n}\n\n.swal2-container {\n  z-index: 99999 !important;\n}\n\n/* CustomToast.css */\n.no-shadow-toast .Toastify__toast {\n  box-shadow: none !important;\n}\n\n.simplebar-placeholder {\n  display: none !important;\n}\n\n\n\n.css-1swivyk-MuiInputBase-input-MuiOutlinedInput-input:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 100px #1E1E2D inset;\n  -webkit-text-fill-color: #fff;\n  caret-color: #fff;\n  border-radius: inherit;\n}\n\n.css-jtnu8p-MuiInputBase-input-MuiOutlinedInput-input:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 100px #1E1E2D inset;\n  -webkit-text-fill-color: #fff;\n  caret-color: #fff;\n  border-radius: inherit;\n}\n\n.link {\n  text-decoration: none;\n  color: #fff;\n}\n\ntextarea::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.toolbar {\n  background-color: #333;\n  color: black;\n}\n\n.rdw-option-wrapper,\n.rdw-dropdown-selectedtext {\n  display: flex;\n  height: 30px;\n  justify-content: 'space-between';\n}\n\n.wrapper {\n  background-color: #333;\n  border-radius: 10px;\n  overflow: hidden;\n  height: 300px;\n  padding-bottom: 70px;\n  transition: 1s all ease;\n}\n\n.wrapper:hover {\n  outline: 1px solid #fff;\n}\n\n/* For WebKit browsers (Chrome, Safari) */\n.editor::-webkit-scrollbar {\n  width: 12px;\n  /* Width of the scrollbar */\n}\n\n.editor::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  /* Background of the scrollbar track */\n  border-radius: 10px;\n  /* Rounded corners for the track */\n}\n\n.editor::-webkit-scrollbar-thumb {\n  background: #888;\n  /* Color of the scrollbar thumb */\n  border-radius: 10px;\n  /* Rounded corners for the thumb */\n}\n\n.editor::-webkit-scrollbar-thumb:hover {\n  background: #555;\n  /* Darker color when hovering over the thumb */\n}\n\n/* For Firefox */\n.editor {\n  scrollbar-width: thin;\n  /* Makes the scrollbar thinner */\n  scrollbar-color: #888 #f1f1f1;\n  /* Thumb color and track color */\n}\n\n/* For Internet Explorer and Edge (if needed) */\n.editor {\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  /* Hides scrollbar when not in use */\n}\n\n.editor {\n  background-color: #333;\n  padding: 0 10px;\n}\n\n.rdw-editor-toolbar {\n  border: 1px solid #333;\n}\n\np {\n  margin: 0;\n  padding: 0;\n}\n\n.custom-select-2 .ant-select-selector {\n  background-color: #333 !important;\n  color: #fff !important;\n  padding: 5px 0;\n}\n\n.custom-select-2 .ant-select-selection-item {\n  color: #fff !important;\n}\n\n/* Style for dropdown menu */\n.custom-select-2 .ant-select-dropdown {\n  background-color: #333 !important;\n}\n\n/* Style for dropdown items */\n.custom-select-2 .ant-select-item-option {\n  background-color: #333 !important;\n  color: #fff !important;\n}\n\n/* Style placeholder text color */\n.custom-select-2 .ant-select-selection-placeholder {\n  color: #888888 !important;\n}\n\n.custom-popup-select {\n  background-color: #333 !important;\n}\n\n.custom-select .ant-select-selector {\n  background-color: #333 !important;\n  color: #fff !important;\n  border-color: #333 !important;\n  padding: 5px 0;\n}\n\n/* Style for dropdown menu */\n.custom-select .ant-select-dropdown {\n  background-color: #333 !important;\n}\n\n/* Style for dropdown items */\n.custom-select .ant-select-item-option {\n  background-color: #333 !important;\n  color: #fff !important;\n}\n\n/* Style placeholder text color */\n.custom-select .ant-select-selection-placeholder {\n  color: #bbb !important;\n}\n\n.anticon,\n.anticon-close {\n  color: #fff\n}\n\n.ant-modal-content,\n.ant-picker {\n  background-color: #333 !important;\n  color: #fff !important;\n}\n\n.ant-modal-content>div {\n  background-color: #333 !important;\n  /* color: #fff !important; */\n}\n\n.ant-modal-body {\n  background-color: #333 !important;\n}\n\n.ant-col>label {\n  color: #fff !important;\n}\n\n.ant-input::placeholder,\n.ant-picker-input>input::placeholder {\n  color: gray !important;\n}\n\n.ant-picker-input-placeholder>input {\n  color: gray !important;\n}\n\n.ant-picker {\n  background-color: #333 !important;\n}\n\n/* Ensure all child elements (like input, buttons, etc.) inside .custom-popup are styled */\n.custom-popup * {\n  background-color: #333 !important;\n  color: #fff !important;\n}\n\n/* Style the DatePicker dropdown specifically */\n.custom-popup .ant-picker-dropdown {\n  background-color: #333 !important;\n  color: #fff !important;\n}\n\n/* Style the cells inside the dropdown */\n.custom-popup .ant-picker-cell-inner {\n  color: #fff !important;\n}\n\n/* Optional: hover state for date cells */\n.custom-popup .ant-picker-cell:hover .ant-picker-cell-inner {\n  background-color: #444 !important;\n  color: #fff !important;\n}\n\n/* Highlight selected date inside the dropdown */\n.custom-popup .ant-picker-cell-selected .ant-picker-cell-inner {\n  background-color: #0BD349 !important;\n  color: #000 !important;\n}\n\n\n\n.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner {\n  background-color: #27c456 !important;\n}\n\n.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {\n  background-color: #27c456 !important;\n}\n\n.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {\n  border-color: #1f9643e5 !important;\n}\n\n.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,\n.ant-picker-cell-in-view.ant-picker-cell-in-range::before,\n.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before,\n.ant-picker-time-panel-column>li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {\n  background: #444 !important;\n}\n\n.ant-btn-primary {\n  background-color: #27c456 !important;\n  border-color: #1f9643e5 !important;\n  box-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
